'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auditresultsummary = require('./auditresultsummary.html');

var _auditresultsummary2 = _interopRequireDefault(_auditresultsummary);

var _auditresultsummary3 = require('./auditresultsummary.controller');

var _auditresultsummary4 = _interopRequireDefault(_auditresultsummary3);

require('./auditresultsummary.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditresultsummaryComponent = {
  restrict: 'E',
  bindings: {},
  template: _auditresultsummary2.default,
  controller: _auditresultsummary4.default,
  controllerAs: 'vm'
};

exports.default = auditresultsummaryComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditresultsummary/auditresultsummary.component.js